import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import Util from "../../validation/index";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { adminCreateRiskRuleMapping } from "../../redux/actions/adminCreateRiskRuleMappingAction";
import { adminGetRiskRuleList } from "../../redux/actions/adminGetRiskRuleListAction";
import { adminAddRiskRule } from "../../redux/actions/adminAddRiskRuleAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

function AdminAddRiskRuleMapping() {
    const [walletOwnerId, setWalletOwnerId] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(false);

    const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
    const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

    const [getRiskRuleListStatus, setGetRiskRuleListStatus] = useState(false);
    const [getRiskRuleListArray, setRiskRuleListArray] = useState([]);

    const [createRiskRuleStatus, setCreateRiskRuleStatus] = useState(false);
    const [createRiskRuleArray, setCreateRiskRuleArray] = useState([]);

    // const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();

    const [search, setSearch] = useState({
        ruleIDSearch: "",
        riskGroupSearch: "",
        statusSearch: ""
    });

    const { ruleIDSearch, riskGroupSearch, statusSearch } = search;

    const handleChange = ({ target: { name, value } }, type) => {
        // setUser({ ...user, [e.target.name]: e.target.value });

        const obj = {
            ...search
        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        }
        setSearch(obj);
    };

    const setValue = ({ target: { name, value } }) => {
        setWalletOwnerId(value)
    }

    const getWalletOwnerIdRes = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );

    const getRiskRuleListRes = useSelector(
        ({ adminGetRiskRuleList }) => adminGetRiskRuleList
    );

    const createRiskRuleMappingRes = useSelector(
        ({ adminCreateRiskRuleMapping }) => adminCreateRiskRuleMapping
    );

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getRiskRuleListReq();
            getWalletOwnerIdAndNameListReq();
        }
    }, [regenerateTokenRes.data.AuthToken]);

    const getWalletOwnerIdAndNameListReq = () => {
        setGetWalletOwnerIdStatus(true);
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: "2"
                        adminId: val.adminIDS
                    }
                },
                authToken
            )
        );
    };

    const getWalletOwnerIdStatusFunc = () => {
        if (getWalletOwnerIdStatus) {
            if (getWalletOwnerIdRes.data.status == "success") {
                setGetWalletOwnerIdResArray(
                    [].concat(getWalletOwnerIdRes.data.ownerList)
                );
            }
            if (getWalletOwnerIdRes.data.status == "failed") {
                setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
                if (
                    getWalletOwnerIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getWalletOwnerIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getWalletOwnerIdStatusFunc();
    }, [getWalletOwnerIdRes.data.status]);

    const getRiskRuleListReq = () => {
        setIsLoading(true);
        setGetRiskRuleListStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                ruleId: ruleIDSearch,
                riskGroup: riskGroupSearch == "All" ? "" : riskGroupSearch,
                ruleStatus: statusSearch == "All" ? "" : statusSearch
            }
        };
        dispatch(adminGetRiskRuleList(req, authToken));
    };

    const getRiskRuleListFunc = () => {
        if (getRiskRuleListStatus) {
            setIsLoading(false);
            if (getRiskRuleListRes.data.status == "success") {
                setRiskRuleListArray([].concat(getRiskRuleListRes.data.riskRuleList));
            }
            if (getRiskRuleListRes.data.status == "failed") {
                setRiskRuleListArray(getRiskRuleListRes.data);
                NotificationPopups(
                    "error",
                    "Failed",
                    getRiskRuleListRes.data.description
                );
                if (
                    getRiskRuleListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRiskRuleListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getRiskRuleListRes.data.status == "NOT FOUND") {
                setRiskRuleListArray(getRiskRuleListRes.data);
                NotificationPopups(
                    "error",
                    "Failed",
                    getRiskRuleListRes.data.description
                );
            }
        }
    };

    useEffect(() => {
        getRiskRuleListFunc();
    }, [getRiskRuleListRes.data.status]);

    const [blockIDS, setBlockIDS] = useState({
        blockId: []
    });

    const handleCheck = (row, e) => {
        const { value, checked } = e.target;
        const { blockId } = blockIDS;
        if (checked) {
            setBlockIDS({
                blockId: [...blockId, row.ruleId]
            });
        } else {
            setBlockIDS({
                blockId: blockId.filter((e) => e !== row.ruleId)
            });
        }
    };

    useEffect(() => {
        console.log(blockIDS.blockId, "////////////////////");
    }, [blockIDS]);

    const createRiskRuleMappingReq = () => {
        setCreateRiskRuleStatus(true);
        let req = {
            loginDetails: {
                walletOwnerId: walletOwnerId
            },
            riskRuleList: blockIDS.blockId.map((x) =>
                getRiskRuleListRes.data.riskRuleList.find((y) => y.ruleId == x)
            )
        };

        dispatch(adminCreateRiskRuleMapping(req, authToken));
    };

    const createRiskRuleMappingFunc = () => {
        if (createRiskRuleStatus) {
            if (createRiskRuleMappingRes.data.status == "success") {
                setCreateRiskRuleArray(createRiskRuleMappingRes.data);
                // getRiskRuleMappingReq();
                // setNotificationOpen(true);
            }
            if (createRiskRuleMappingRes.data.status == "failed") {
                setCreateRiskRuleArray(createRiskRuleMappingRes.data);
                // getRiskRuleMappingReq();
                // setNotificationOpen(true);
                if (
                    createRiskRuleMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    createRiskRuleMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        createRiskRuleMappingFunc();
    }, [createRiskRuleMappingRes.data.status]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    // style={{ padding: "25px", gap: "20px" }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={4}></Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                required
                                size="small"
                                color="primary"
                                type="text"
                                label="Owner ID"
                                variant="standard"
                                fullWidth={true}
                                name="walletOwnerId"
                                // value={walletOwnerId || ""}
                                defaultValue={"Select Owner Id" || walletOwnerId}
                                onChange={setValue}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdResArray.map((x) => (
                                        <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getRiskRuleListArray.length == undefined ||
                    getRiskRuleListArray.status == "NOT FOUND" ||
                    !getRiskRuleListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"
                                
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    // style={{ backgroundColor: "#00b9f5", color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"
                                
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                                {/* <Checkbox
                                                // checked={moduleList.moduleListArr.includes(
                                                // 	x.moduleName.split("_")[0] +
                                                // 		"_" +
                                                // 		x.moduleName.split("_")[1]
                                                // )}
                                                /> */}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Rule ID
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Rule Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Risk Group
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Status
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {getRiskRuleListArray &&
                                            []
                                                .concat(getRiskRuleListArray)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow>
                                                        <TableCell align="center"><Checkbox
                                                            checked={blockIDS.blockId.includes(row.ruleId)}
                                                            onChange={(e) => handleCheck(row, e)}
                                                            color="primary"
                                                        /></TableCell>
                                                        <TableCell align="center">{row.ruleId}</TableCell>
                                                        <TableCell align="center">{row.ruleName}</TableCell>
                                                        <TableCell align="center">
                                                            {row.riskGroup}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.isActive == "Y" ? "Enable" : "Disable"}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getRiskRuleListArray.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                                <div className="text-center">
                                    <CustomButton
                                        style={{
                                            padding: "8px"
                                        }}
                                        onClick={createRiskRuleMappingReq}
                                    >
                                        Save
                                    </CustomButton>
                                </div>
                            </TableContainer>
                        </Grid>
                    </Card>
                )}
            </Layout>

            {/* {addOrUpdateRiskRuleArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addOrUpdateRiskRuleArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addOrUpdateRiskRuleArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addOrUpdateRiskRuleArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )} */}
        </>
    );
}

export default AdminAddRiskRuleMapping;
